<div class="range" [class.small-mode]="smallMode()">
    {{ fromDate()  | date: "shortDate"  }}
    <div class="icons">
        <span
            class="icon"
            [class.in-market]="saleSelection() === periodDefinitionType.InMarket"
            [class.registered]="saleSelection() === periodDefinitionType.Registered"
            [class.sold]="saleSelection() === periodDefinitionType.Sold"
            [class.small-mode]="smallMode()"
        ></span>
    </div>
    {{ toDate()  | date: "shortDate"  }}
</div>
